module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-file"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--colored"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("open_in_browser")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.i18n().tapOrDrop))])]), _vm._v(" "), _c('input', {
    staticClass: "hidden-file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleInputChange
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12833f38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/LoadFile.vue
// module id = 434
// module chunks = 0